__turbopack_context__.v({
  "root": "zvg-Ka_root",
  "tableTd__iIuUs": "zvg-Ka_tableTd__iIuUs",
  "tableTd__nJh7": "zvg-Ka_tableTd__nJh7",
  "tableTd__oGcT": "zvg-Ka_tableTd__oGcT",
  "tableTd__qK5A1": "zvg-Ka_tableTd__qK5A1",
  "tableTr__osIMv": "zvg-Ka_tableTr__osIMv",
  "text___1HHCk": "zvg-Ka_text___1HHCk",
  "text__eQ1Dc": "zvg-Ka_text__eQ1Dc",
  "text__gbcKr": "zvg-Ka_text__gbcKr",
  "text__hdVT": "zvg-Ka_text__hdVT",
});
